import { useContext } from 'react';

import ConfigContext, {
  ConfigContextProps,
} from '@/data/context/ConfigContext';

const useConfigContext = (): ConfigContextProps => useContext(ConfigContext);

export default useConfigContext;
